
/*
	the one message-length limit. the composer's maxLength and both server-side checks in feathers'
	message-service (sendUserMessage and the legacy create()) read it from here, so they cannot disagree.
*/
export const maxMessageTextLength = 4000

export type MessageSenderType = 'user' | 'bot' | 'system' | 'error' | 'admin'

export interface MessageAttachment {
	attachmentId: string
	downloadUrl?: string
	previewUrl?: string
}

export interface MessageData {
	channelId: string
	senderType: MessageSenderType
	senderId: string
	text?: string
	attachments?: MessageAttachment[]

	//	we're storing senderName in addition to senderId,
	//	because in public channels (with lots of members)
	//	the frontend doesn't get a full list of members.
	senderName?: string
	senderColor?: string

	senderDeleted?: boolean

	//	reactions stored as JSON string: map of emoji shortcode to array of user IDs
	//	example: {"thumbs-up": ["u-abc123", "u-def456"], "heart": ["u-abc123"]}
	//	parsed on frontend for display, on backend only when modifying
	reactions?: string

	visibleOnlyToUserId?: string
}

export interface Message extends MessageData {
	ulid: string
}
